import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { sortProjectPrioritiesByValue } from 'services/projectService';
import SimpleModal from 'components/simpleModal';

const getModalBody = (data) => {
    let modalBodyText = '';
    if (data ?.busValPriorityParams && data ?.busValPriorityParams ?.length > 0) {
        modalBodyText += ('<b>Business value priority parameters (name and value)</b><br/>');
        const sortedBusValData = sortProjectPrioritiesByValue(data ?.busValPriorityParams);
        if (sortedBusValData && sortedBusValData ?.length > 0) {
            for (const element of sortedBusValData.reverse()) {
                const lineContent = element.name.concat(' ').concat(element.value).concat('<br/>');
                modalBodyText += lineContent;
            }
        }
    } else {
        modalBodyText += ('<b>No business value priority parameters have been specified.</b><br/>');
    }

    if (data ?.costImplPriorityParams && data ?.costImplPriorityParams ?.length > 0) {
        modalBodyText += ('<b>Cost implementation priority parameters (name and value)</b><br/>');
        const sortedCostImplData = sortProjectPrioritiesByValue(data ?.costImplPriorityParams);
        if (sortedCostImplData && sortedCostImplData ?.length > 0) {
            for (const element of sortedCostImplData.reverse()) {
                const lineContent = element.name.concat(' ').concat(element.value).concat('<br/>');
                modalBodyText += lineContent;
            }
        }
    } else {
        modalBodyText += ('<b>No cost implementation priority parameters have been specified.</b><br/>');
    }

    return modalBodyText;
};

function ProjectListItem({ data, onProjectCostPrioritiesDashboard, onProjectBusinessPrioritiesDashboard }) {
    const { name, description, weight } = data;
    return (
        <div className="user-list d-sm-flex flex-sm-row card" style={{ marginLeft: '5px', width: '99%', marginBottom: '5px' }}>
            <div className="description col-xl-1 col-lg-1 col-md-1">
                <div className="bg-blue avatar rounded-circle size-40 text-white d-flex align-items-center justify-content-center mx-1 mx-md-3" style={{ fontSize: 16 }}>
                    {name ? name.charAt(0).toUpperCase() : ''}
                </div>
            </div>
            <div className="description col-xl-8 col-lg-8 col-md-8">
                <h3>{name}</h3>
                <p>{description}</p>
                <ListGroup className="list-inline d-sm-flex flex-sm-row gx-btn-list">
                    <ListGroupItem className="border-0">
                        <SimpleModal modalTitle='Project Priority Details' buttonText='More info' modalBody={getModalBody(data)} />
                    </ListGroupItem>
                    <ListGroupItem className="border-0">
                        <a className="btn btn-light jr-btn-rounded" href="javascript:void(0)" onClick={onProjectCostPrioritiesDashboard}>Cost priorities</a>
                    </ListGroupItem>
                    <ListGroupItem className="border-0">
                        <a className="btn btn-light jr-btn-rounded" href="javascript:void(0)" onClick={onProjectBusinessPrioritiesDashboard}>Business priorities</a>
                    </ListGroupItem>
                </ListGroup>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-3">
                <div className="border-0 text-center bg-white">
                    <h3>Weight - {weight}</h3>
                </div>
            </div>
        </div >
    );
}

export default ProjectListItem;


// WEBPACK FOOTER //
// ./components/Agile/OrgDashboard/projectListItem/projectListItem.js